import { Quill } from "react-quill";

export const modulesDescription = {
    toolbar: {
        container: "#toolbar-description",
    }
};

export const modulesSpeaker = {
    toolbar: {
        container: "#toolbar-speaker",
    }
};

export const editModulesDescription = {
    toolbar: {
        container: "#toolbar-editDescription",
    }
};

export const editModulesSpeaker = {
    toolbar: {
        container: "#toolbar-editSpeaker",
    }
};

const Font = Quill.import('formats/font');
Font.whitelist = ['serif', 'monospace', 'roboto', 'playfair', 'montserrat'];
Quill.register(Font, true);

const Size = Quill.import('formats/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '32px', '48px'];
Quill.register(Size, true);

export const formats = [
    'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'header', 'blockquote', 'code-block',
    'indent', 'list',
    'direction', 'align',
    'link', 'image', 'video', 'formula',
];

const colors = ["#C0C0C0", "#808080", "#FF0000", "#800000", "#FFFF00", "#808000", "#00FF00", "#008000", "#00FFFF", "#008080", "#0000FF", "#000080", "#FF00FF", "#800080",
    "#e67e22", "#b7950b"
];
export const quillFormats = [
    [
        {
            className: "ql-font",
            options: ['serif', 'monospace', 'roboto', 'playfair', 'montserrat']
        },
        {
            className: "ql-size",
            options: ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '32px', '48px']
        }
    ],
    [
        { className: "ql-bold" }, { className: "ql-italic" }, { className: "ql-underline" }, { className: "ql-strike" }
    ],
    [
        {
            className: "ql-color",
            options: colors
        },
        {
            className: "ql-background",
            options: colors
        }
    ],
    [
        {
            className: "ql-script",
            value: "sub"
        },
        {
            className: "ql-script",
            value: "super"
        }
    ],
    [
        {
            className: "ql-header",
            value: "1"
        },
        {
            className: "ql-header",
            value: "2"
        },
        {
            className: "ql-blockquote"
        },
        {
            className: "ql-code-block"
        }
    ],
    [
        {
            className: "ql-list",
            value: "ordered"
        },
        {
            className: "ql-list",
            value: "bullet"
        },
        {
            className: "ql-indent",
            value: "-1"
        },
        {
            className: "ql-indent",
            value: "+1"
        }
    ],
    [
        {
            className: 'ql-direction',
            value: 'rtl'
        },
        {
            className: 'ql-align',
            options: ['right', 'center', 'justify']
        }
    ],
    [
        { className: 'ql-link' }, { className: 'ql-image' }, { className: 'ql-video' }, { className: 'ql-formula' }
    ]
];